const ResponsiveImages = (props) => {
  return (
    (props.ImageProperties === 'small-bleed' && {
      sizes: '(min-width: 640px) 315px, (min-width: 1024px) 403px, 100vw',
    }) ||
    (props.ImageProperties === 'mini-bleed' && {
      sizes: '(min-width: 640px) 315px, (min-width: 1024px) 193px, 100vw',
    }) ||
    (props.ImageProperties === 'mini' && {
      sizes: '(min-width: 640px) 315px, (min-width: 1024px) 193px, 100vw',
    }) ||
    (props.ImageProperties === 'mini-reverse' && {
      sizes: '(min-width: 640px) 315px, (min-width: 1024px) 193px, 100vw',
    }) ||
    (props.ImageProperties === 'xsmall-bleed' && {
      sizes: '(min-width: 640px) 315px, (min-width: 1024px) 300px, 100vw',
    }) ||
    (props.ImageProperties === 'xsmall' && {
      sizes: '(min-width: 640px) 315px, (min-width: 1024px) 300px, 100vw',
    }) ||
    (props.ImageProperties === 'xsmall-reverse' && {
      sizes: '(min-width: 640px) 315px, (min-width: 1024px) 300px, 100vw',
    }) ||
    (props.ImageProperties && { sizes: '(min-width: 640px) 652px, 100vw' })
  );
};

export default ResponsiveImages;
